
/* @ts-ignore */
import { translations } from "@/mixins";
import VueTimepicker from "vue2-timepicker";
import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css' 
import moment from "moment";
import {mapGetters} from "vuex";
/* @ts-ignore */
@Component({
  components: {
    VueTimepicker,
  },
  computed: {
    ...mapGetters({
    }),
  },
  mixins: [translations]
})
export default class StoreTimes extends Vue {
  days: Array<any> = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  /* @ts-ignore */
  @Prop() openingHours!: Array<any>;
  /* @ts-ignore */
  @Prop() openingHoursDelivery!: Array<any>;
  /* @ts-ignore */
  @Prop() openingHoursPickup!: Array<any>;
  /* @ts-ignore */
  @Prop() originalOpeningHours!: Array<any>;
  toggle: Boolean = false;
  translate!: Function
  hasStoreTimes: Boolean = false;

  mounted() {    
    // Wait for next tick to ensure all props are available
    this.$nextTick(() => {
      this.validateInitialState();
    });
  }

  // Method to re-validate state when needed
  public revalidateState() {
    this.validateInitialState();
  }

  private validateInitialState() {
    // Check if we have separate delivery and pickup hours with valid data
    const hasDeliveryHours = this.hasValidHours(this.openingHoursDelivery);
    const hasPickupHours = this.hasValidHours(this.openingHoursPickup);
    
    // Check if we have original opening hours with valid data
    const hasOriginalHours = this.hasValidHours(this.originalOpeningHours);
    
    // If we have both delivery and pickup hours, show separate tabs
    if (hasDeliveryHours && hasPickupHours) {
      this.toggle = true;
      this.hasStoreTimes = true;
    } 
    // If we have original opening hours but no separate delivery/pickup, show single view
    else if (hasOriginalHours) {
      this.toggle = false;
      this.hasStoreTimes = true;
    } 
    // Default to separate tabs for new locations
    else {
      this.toggle = false;
      this.hasStoreTimes = false;
      
      // Trigger default hours population for new locations
      this.$nextTick(() => {
        this.$emit("setDefaultHours", this.toggle, this.hasStoreTimes);
      });
    }
  }

  /* @ts-ignore */
  @Watch('originalOpeningHours', { immediate: true, deep: true })
  onOriginalOpeningHoursChanged(hours: any) {
    // Add null/undefined check
    if (hours) {
      this.validateInitialState();
    }
  }
  /* @ts-ignore */
  @Watch('toggle', { immediate: true, deep: true })
  onToggle(value: Boolean) {
    // Emit the event to trigger default hours population
    this.$emit("setDefaultHours", value, this.hasStoreTimes);
    
    // Also trigger immediate validation to ensure data consistency
    this.$nextTick(() => {
      this.validateAndPopulateDefaults(value);
    });
  }

  // Method to validate and populate defaults when toggle changes
  private validateAndPopulateDefaults(toggleValue: Boolean) {
    if (toggleValue) {
      // Toggle is ON - check delivery and pickup hours
      const hasValidDeliveryHours = this.hasValidHours(this.openingHoursDelivery);
      const hasValidPickupHours = this.hasValidHours(this.openingHoursPickup);
      
      // If either is missing valid data, emit to populate defaults
      if (!hasValidDeliveryHours || !hasValidPickupHours) {
        this.$emit("setDefaultHours", toggleValue, false);
      }
    } else {
      // Toggle is OFF - check main opening hours
      const hasValidMainHours = this.hasValidHours(this.openingHours);
      
      // If main hours are missing valid data, emit to populate defaults
      if (!hasValidMainHours) {
        this.$emit("setDefaultHours", toggleValue, false);
      }
    }
  }

  // Helper method to check if hours have valid time data
  private hasValidHours(hours: any[]): boolean {
    if (!hours || hours.length === 0) return false;
    
    return hours.some((hour: any) => {
      return hour && hour.open && hour.closed && 
             hour.open.toString().trim() !== '' && 
             hour.closed.toString().trim() !== '' &&
             hour.open !== 'Data inválida' && 
             hour.closed !== 'Data inválida';
    });
  }

  /* @ts-ignore */
  @Watch('openingHours', { immediate: true, deep: true })
  onOpeningHoursChanged(hours: any) {
    if (hours && hours.length > 0) {
      // Check if we have actual time data, not just empty objects
      const hasValidHours = this.hasValidHours(hours);
      if (hasValidHours) {
        this.hasStoreTimes = true;
      } else {
        // If hours exist but are invalid, trigger default population when toggle is OFF
        if (!this.toggle) {
          this.$nextTick(() => {
            this.$emit("setDefaultHours", this.toggle, false);
          });
        }
      }
      
      hours.map(
        (item: any) => {
          // Only format if the values are valid and not empty
          if (item.open && item.open !== 'Data inválida' && item.open.toString().trim() !== '') {
            try {
              item.open = moment(`${item.open}`, "hh:mm A").format("HH:mm");
            } catch (e) {
              console.error('Error formatting open time:', item.open);
            }
          }
          if (item.closed && item.closed !== 'Data inválida' && item.closed.toString().trim() !== '') {
            try {
              item.closed = moment(`${item.closed}`, "hh:mm A").format("HH:mm");
            } catch (e) {
              console.error('Error formatting closed time:', item.closed);
            }
          }
          return item;
        }
      );
    }
    
    // Re-validate state after data changes
    this.$nextTick(() => {
      this.validateInitialState();
    });
  }
  /* @ts-ignore */
  @Watch('openingHoursDelivery', { immediate: true, deep: true })
  onOpeningHoursDeliveryChanged(hours: any) {
    if (hours && hours.length > 0) {
      // Check if we have actual time data
      const hasValidHours = this.hasValidHours(hours);
      if (hasValidHours) {
        this.hasStoreTimes = true;
      } else {
        // If hours exist but are invalid, trigger default population when toggle is ON
        if (this.toggle) {
          this.$nextTick(() => {
            this.$emit("setDefaultHours", this.toggle, false);
          });
        }
      }
      
      hours.map(
        (item: any) => {
          // Only format if the values are valid
          if (item.open && item.open !== 'Data inválida') {
            try {
              item.open = moment(`${item.open}`, "hh:mm A").format("HH:mm");
            } catch (e) {
              console.error('Error formatting open time:', item.open);
            }
          }
          if (item.closed && item.closed !== 'Data inválida') {
            try {
              item.closed = moment(`${item.closed}`, "hh:mm A").format("HH:mm");
            } catch (e) {
              console.error('Error formatting closed time:', item.closed);
            }
          }
          return item;
        }
      );
    }
    
    // Re-validate state after data changes
    this.$nextTick(() => {
      this.validateInitialState();
    });
  }

  /* @ts-ignore */
  @Watch('openingHoursPickup', { immediate: true, deep: true })
  onOpeningHoursPickupChanged(hours: any) {
    if (hours && hours.length > 0) {
      // Check if we have actual time data
      const hasValidHours = this.hasValidHours(hours);
      if (hasValidHours) {
        this.hasStoreTimes = true;
      } else {
        // If hours exist but are invalid, trigger default population when toggle is ON
        if (this.toggle) {
          this.$nextTick(() => {
            this.$emit("setDefaultHours", this.toggle, false);
          });
        }
      }
      
      hours.map(
        (item: any) => {
          // Only format if the values are valid
          if (item.open && item.open !== 'Data inválida') {
            try {
              item.open = moment(`${item.open}`, "hh:mm A").format("HH:mm");
            } catch (e) {
              console.error('Error formatting open time:', item.open);
            }
          }
          if (item.closed && item.closed !== 'Data inválida') {
            try {
              item.closed = moment(`${item.closed}`, "hh:mm A").format("HH:mm");
            } catch (e) {
              console.error('Error formatting closed time:', item.closed);
            }
          }
          return item;
        }
      );
    }
    
    // Re-validate state after data changes
    this.$nextTick(() => {
      this.validateInitialState();
    });
  }

  get hasDeliveryAndPickup(): Boolean {
    return this.toggle
  }

  set hasDeliveryAndPickup(value: Boolean) {
    this.toggle = value
  }

}
